// extracted by mini-css-extract-plugin
export default {"skeleton":"ArchivedProjectSkeleton_skeleton__FgRVF"};